import React from "react";
import EmptyCart from "./emptycart";
import styles from "./empty.module.scss";
function Empty({ heading, body }: { heading: string; body: string }) {
  return (
    <div className={styles.empty}>
      <EmptyCart />
      <h2>{heading}</h2>
      <p>{body}</p>
    </div>
  );
}

export default Empty;
